/**
 * @file components/Source/component.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */

export function Source(props) {
    if (!props.sourceInfo) {
        return null;
    }

    return (
        <div className="source" data-testid="source">
            <p>{props.sourceInfo}</p>
        </div>
    );
}

export default Source;
